import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'thehubz-asset-progress-bar',
  templateUrl: './asset-progress-bar.component.html',
  styleUrls: ['./asset-progress-bar.component.scss'],
  standalone: true,
  imports: [MatProgressBarModule],
})
export class AssetProgressBarComponent implements OnChanges {
  @Input() assetCount!: number;
  @Input() lastVisibleAssetIndex!: number;

  currentPercent!: number;
  currentAssetCount!: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['lastVisibleAssetIndex']) {
      this.updateProgress();
    }
  }

  updateProgress() {
    this.currentAssetCount = this.lastVisibleAssetIndex + 1;
    this.currentPercent = Math.round((this.currentAssetCount / this.assetCount) * 100);
  }
}
